import { parseISO } from 'date-fns';

export const convertCentsToDollars = (cents: number): number => cents && cents / 100;

export const convertDollarsToCents = (dollars: number): number => dollars && +dollars * 100;

/**
 * Convert YYYY-MM-DD to MM/DD/YYYY
 * This does not handle dates with times since it won't respect the TZ.
 * @param date
 */
export const convertSqlDateToUSCalendarDate = (date: string) => {
  if (!date) return '';

  // const truncated = date.substring(0,10);
  const [year, month, day] = date.split('-');
  const result = [month, day, year].join('/');
  return result;
};

/**
 * Convert MM/DD/YYYY to YYYY-MM-DD
 * @param date
 */
export const convertUSCalendarDateToSqlDate = (date: string) => {
  if (!date) return '';
  const [month, day, year] = date.split('/');
  const result = [year, month, day].join('-');
  return result;
};

/**
 * 22months -> 1 year and 10 months
 * @param monthCount
 * @returns
 */
export const convertMonthsToYears = (monthCount: number) => {
  const getPlural = (number: number, word: { one: string; other: string }) => {
    return (number === 1 && word.one) || word.other;
  };

  const months = { one: 'month', other: 'months' },
    years = { one: 'year', other: 'years' },
    m = monthCount % 12,
    y = Math.floor(monthCount / 12),
    result = [];

  if (y) result.push(y + ' ' + getPlural(y, years));
  if (m) result.push(m + ' ' + getPlural(m, months));
  return result.join(' and ');
};

/**
 * converts a raw string into an html encode string to avoid Cross Site Scripting (XSS) attacks
 * input = "<div>Hello, 'world'!</div>"
 * output = &lt;div&gt;Hello, &#039;world&#039;!&lt;/div&gt
 * @param str
 * @returns
 */
export const htmlEncode = (str: string) => {
  const encodedString = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  return encodedString;
};


/**
 * Returns a date object using the date only string along with an optional time component, in UTC.
 * This is useful when you have to construct a date object but your date part and time part are separate strings.
 * @param isoDateOnly format in `yyyy-MM-dd`
 * @param isoTimeOnly optional string format in `hh:mm:ss` 24
 * @returns a date object
 */
export const parseDateOnlyIsoToUtc = (isoDateOnly: string, isoTimeOnly: string = '00:00:00') => {
  const parsedDateUtc = parseISO(`${isoDateOnly}T${isoTimeOnly}Z`);
  return parsedDateUtc;
};
